import { Image } from '@chakra-ui/react';
import { getAssetUrl } from '@cronos-app/chakra';

import { Token } from '../model';
import type { TokenRegister } from './types';

export const getAgentFunToken: TokenRegister = (desiredNetwork, sdks) => {
  return {
    type: Token.AGENTFUN,
    symbol: 'AGENTFUN',
    addressL1: '',
    addressL2: sdks.L2.getContractAddress('AGENTFUN'),
    addressCronosEvm: '',
    decimals: 18,
    displayDecimals: 6,
    Icon: (props) => (
      <Image
        src={getAssetUrl('/tokens/agentfun.svg')}
        boxSize="24px"
        // eslint-disable-next-line @ts-intl/ts-intl/no-raw-text
        alt="AGENTFUN"
        {...props}
      />
    ),
  };
};
